import {ModalIsland} from "@/shared/reactIslandModal";
import {PdfPreviewModal, PdfPreviewModalProps} from "./PdfPreviewModal";

let previewModal: ModalIsland<PdfPreviewModalProps> | null = null;

/** Opens the preview of an export job, sharing one lazily mounted dialog across all pages. */
export function showPdfPreview(title: string, exportJobId: string, loadingMessage?: string) {
	previewModal ??= new ModalIsland<PdfPreviewModalProps>(PdfPreviewModal, {title, exportJobId: null});
	previewModal.Open({title, exportJobId, loadingMessage});
}
